import {createAction} from '@reduxjs/toolkit';
import {type Feature} from '@src/types/featureCollections.ts';
import {type Product} from '@src/types/products.ts';

const actionPrefix = 'QUOTA_RESERVATIONS';

export const selectProduct = createAction<Product | null>(
  `${actionPrefix}/SELECT_PRODUCT`,
);

export const selectFeatures = createAction<Feature[] | null>(
  `${actionPrefix}/SELECT_FEATURES`,
);
